import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { JSEncrypt } from 'jsencrypt';

import { OTP, Typography } from 'mobily-ui-library';
import { GlobalContext } from '../../../context/GlobalContext';

import { promotionQualification, subsidyEligibilityCheck, installmentPackageEligibility, cemValidateOTP, getAccountByNumber, cemResendOTP } from '../../../api/api';

import { handleApiError } from '../../../functions/handleApiError';

import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';
import ErrorModal from '../../ErrorModal/ErrorModal';

import './DeviceOTP.scss';
interface Props {
    timer: number;
    setTimer: (value: any) => void;
    handleHeaderCancel: () => void;
}

const win: any = window;
let CustomerEnquiryCounter = 0;
const retryCustomerEnquiryCount = 1;

function DeviceOTP({ handleHeaderCancel, setTimer, timer }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, msisdn, OTPData, scData, productId, productData, deviceFlow, graphQlResponse, subPageToDisplay: stepName, journeyName, homePageUrl } = state;
    const { t } = useTranslation();
    const uniqueProductNameArr = graphQlResponse?.getProductOfferByID[0]?.specCharValueUse.filter((val: any) => (val.name === 'Unique Technical Name'))[0];
    const uniqueProductName = uniqueProductNameArr?.specCharacteristicValue[0]?.value ? uniqueProductNameArr?.specCharacteristicValue[0]?.value : "";
    const sku = graphQlResponse?.getProductOfferByID[0]?.specCharValueUse.filter((val: any) => (val.name === 'SKU'))[0]?.specCharacteristicValue[0]?.value;

    const [otpValue, setotpValue] = useState('');
    const [showOTPError, setShowOTPError] = useState(false);
    const [notEligible, setNotEligible] = useState(false);
    const [notCustomer, setNotCustomer] = useState(false);
    const [subsidyErrorTitle, setSubsidyErrorTitle] = useState('');
    const [subsidyErrorBody, setSubsidyErrorBody] = useState('');
    const [errorMessage, setErrorMessage] = useState("");
    const [installmentErrorTitle, setInstallmentErrorTitle] = useState('');
    const [installmentErrorBody, setInstallmentErrorBody] = useState('');
    const [isInstallmentError, SetIsInstallmentError] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isGenericError, setIsGenericError] = useState(false);
    const [resendOption, setResendOption] = useState(true);
    const [isOTPDisabled, setIsOTPDisabled] = useState(false);

    const [transId, setTransId] = useState('');
    const [errorCode, setErrorCode] = useState('');

    const cemPublicKey = win['cem_public_key'];
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(cemPublicKey);
    const bmClientId = win['BM_CI'];
    const bmClientSecret = win['BM_CS'];
    const [errorTitle, setErrorTitle] = useState('');
    const [errorModal, setErrorModal] = useState(false);
    const [isServiceError, setIsServiceError] = useState(false)

    const refId = OTPData?.data?.refId ? OTPData?.data?.refId : "";

    const installmentErrorCodes = ['26215', '2118', '1112', '26216', '1111', '26217', '26218',
        '26219', '26220', '26224', '26238', '26721', '26722', '26723', '26724', '9010', '26727'];

    const activeFlow = deviceFlow || sessionStorage.getItem('device-flow');

    useEffect(() => {
        let countdown: any;
        const countdownFunction = () => {
            countdown = setInterval(() => {
                setTimer((prevTimer: any) => {
                    if (prevTimer > 0) {
                        return prevTimer - 1;
                    } else {
                        clearInterval(countdown);
                        return 0;
                    }
                });
            }, 1000);
        }
        countdownFunction();

        return () => clearInterval(countdown);
        
    }, [timer]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleOTPChange = (otp: any) => {
        setotpValue(otp);

        if (otp.length === 4) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            dispatch({ type: "CAPTURE_OTP_VALUE", payload: { otpValue: otp } });
            // validateOTPAPI(otp);
            cemValidateOTPAPI(otp)
        }
    }

    const handleNotCustomer = () => {
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceLogin' } });
        setNotCustomer(false);
        document.body.style.overflow = 'auto';
        // childRef?.current?.removeMobileNumber();
    }

    const handleInstallmentPopup = () => {
        dispatch({ type: "LOADER", payload: { loading: false } });
        if (isInstallmentError) {
            if (isInstallmentError) {
                SetIsInstallmentError(false);
            } else {
                setShowError(false);
            }
            document.body.style.overflow = 'auto';
        } else {
            setShowError(false);
        }

    }

    const cemValidateOTPAPI = (otp: any) => {
        const EnBmClientId = bmClientId ? jsencrypt.encrypt(bmClientId) : "";
        const EnBmClientSecret = bmClientSecret ? jsencrypt.encrypt(bmClientSecret) : "";
        const req = { otp, refId, EnBmClientId, EnBmClientSecret };

        cemValidateOTP(req)
            .then((res: any) => {
                console.log("response", res)
                if (res.status === 200) {
                    if (res?.data?.status?.sourceCode === "MAPI-000") {
                        const pNumber = msisdn.length > 0 ? msisdn.replace(/^0/, "966") : '';
                        const accessToken = res?.data?.data?.access_token;
                        dispatch({ type: 'ACCESS_TOKEN', payload: { accessToken: res?.data?.data?.access_token } })
                        dispatch({ type: "LOADER", payload: { loading: true } });
                        getAccountByNumberApi(pNumber, accessToken);
                    } else {
                        setErrorCode(res?.status);
                        setIsGenericError(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                    setShowOTPError(true);
                    window.scrollTo(300, 500);
                } else if (res?.status === 260) {
                    // Handle otp error cases
                    switch (res?.data?.status?.sourceCode) {
                        case "MAPI-260-2":
                            setErrorMessage(t("error_Invalid_OTP"));
                            setShowOTPError(true);
                            break;
                        case "MAPI-260-3":
                            setErrorMessage(t("error_OTP_expired"));
                            setShowOTPError(true);
                            break;
                        case "MAPI-260-4":
                            setIsOTPDisabled(true);
                            setErrorMessage(t("error_Max_attempt_reached"));
                            setShowOTPError(true);
                            break;
                        default:
                            setErrorCode(res?.data?.status?.sourceCode);
                            setIsGenericError(true);
                            break;
                    }
                    setTimer(0);
                    setotpValue('');
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else if (res?.status >= 500) {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setShowError(true);
                } else {
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                }
            }).catch(err => {
                setErrorCode(err?.response?.status);
                setIsGenericError(true);
                dispatch({ type: "LOADER", payload: { loading: false } });
            })
    }
  
    const getAccountByNumberApi = (msisdn: string, accessToken: any) => {
        getAccountByNumber(msisdn, journeyName, accessToken)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res.data?.MSISDN) {
                        if (activeFlow === "subsidy") {
                            eligbilityCheckAPI();
                        } else {
                            installmentEligbilityCheckAPI(res?.data);
                        }
                        dispatch({ type: 'CUSTOMER_ACCOUNT_BY_NUMBER', payload: { customerAccount: res?.data } })
                    } else if (res.status === 500 && res.data?.ErrorCode === "500") {
                        if (CustomerEnquiryCounter < retryCustomerEnquiryCount) {
                            getAccountByNumberApi(msisdn, accessToken)
                            CustomerEnquiryCounter++
                        } else {
                            dispatch({ type: 'LOADER', payload: { loading: false } });
                            setErrorModal(true)
                            setErrorTitle(t('customerErrorTitle'))
                        }
                    } else {
                        setNotCustomer(true);
                        const errCode = res?.status;
                        setTransId(res?.config?.headers['X-Transaction-Id']);
                        setErrorCode(errCode);

                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                } else {
                    handleApiError(res, stepName);
                }
            }).catch(err => {
                handleApiError(err, stepName);
            })
    }

    const eligbilityCheckAPI = () => {
        const req = {
            msisdn: msisdn.replace(/^0/, "966"),
            packageId: productId,
            sku
        }

        subsidyEligibilityCheck(req)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res.data.status.code === 'CEM_0000') {
                        setNotEligible(false);
                        let promotionType = '';

                        if (res.data.eligibleRaqiPromotions.length > 0) {
                            promotionType = 'Raqi';
                            dispatch({ type: 'RAQI_PROMOTION', payload: { raqiPromotion: res.data.eligibleRaqiPromotions, promotionType: 'Raqi' } })
                        }

                        if (res.data.eligibleWajidPromotions.length > 0) {
                            promotionType = 'Wajid';
                            dispatch({ type: 'WAJID_PROMOTION', payload: { wajidPromotion: res.data.eligibleWajidPromotions, promotionType: 'Wajid' } })
                        }

                        if (res.data.eligibleRaqiPromotions.length > 0 || res.data.eligibleWajidPromotions.length > 0) {
                            promotionQualificationAPI(promotionType)
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                        }
                        dispatch({ type: "LOADER", payload: { loading: false } });

                    } else {
                        const errCode = res?.status;
                        setTransId(res?.config?.headers['X-Transaction-Id']);
                        setErrorCode(errCode);

                        const errorCode = res.data.status.code;
                        const specialErrorCodes = ['CEM_9754', 'CEM_9001', 'E200001', 'E200002', 'E999995', 'CEM_26235', 'CEM_9004'];
                        const allErrorCodes = ['CEM_26230', 'CEM_9003', 'CEM_26233', 'CEM_26234', 'CEM_26913', 'CEM_1325', 'CEM_9010', 'CEM_9754', 'CEM_9001', 'E200001', 'E200002', 'E999995', 'CEM_26235', 'CEM_9004'];
                        if (allErrorCodes.includes(errorCode)) {
                            setSubsidyErrorTitle(t(`${errorCode}_title`));
                            if (specialErrorCodes.includes(errorCode)) {
                                setSubsidyErrorBody(`${t(`${errorCode}_body`)}: ${res.data.status.sourceCode}`);
                            }
                            else {
                                setSubsidyErrorBody(t(`${errorCode}_body`));
                            }
                        } else {
                            setSubsidyErrorTitle(t("HTTP_error_title"))
                            setSubsidyErrorBody(t("HTTP_error_body"))
                        }

                        setNotEligible(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                } else {
                    setSubsidyErrorTitle(t("HTTP_error_title"))
                    setSubsidyErrorBody(`${t("HTTP_error_body")}: ${res?.data?.status?.sourceCode}`);
                    setNotEligible(true);
                    dispatch({ type: "LOADER", payload: { loading: false } });
                }
            }).catch(err => {
                setSubsidyErrorTitle(t("HTTP_error_title"))
                setSubsidyErrorBody(`${t("HTTP_error_body")}: ${err?.response?.status}`);
                setNotEligible(true);
                dispatch({ type: "LOADER", payload: { loading: false } });
            })
    }

    const installmentEligbilityCheckAPI = (customerInquiry: any) => {
        const sanNum = customerInquiry?.ServiceAccountNumber ? customerInquiry?.ServiceAccountNumber : '';
        const shoppingCartID = scData?.id
        const productOfferId = productData?.id
        const req = {
            msisdn: msisdn.replace(/^0/, "966"),
            packageId: uniqueProductName,
            san: sanNum,
            shoppingCartId: shoppingCartID,
            productOfferId: productOfferId
        }

        installmentPackageEligibility(req)
            .then((res: any) => {
                const sourceCode = res.data?.status?.sourceCode;
                setInstallmentErrorTitle(t(`${res.data?.status?.sourceCode}_title`))
                setInstallmentErrorBody(t(`${res.data?.status?.sourceCode}_body`))
                if (res.status === 200 && res.data) {
                    if (res?.data?.status?.code === "CEM_0000") {
                        const whitelistFlag = res.data?.whitelistFlag ? res.data?.whitelistFlag : "";
                        const blacklistFlag = res.data?.blacklistFlag ? res.data?.blacklistFlag : "";
                        const plans = res.data?.deviceInstallmentPromotions ? res.data?.deviceInstallmentPromotions : [];
                        if ((plans?.length >= 1) && (whitelistFlag === "Y" || blacklistFlag === "N")) {
                            dispatch({ type: "INSTALMENT_PACKAGE_ELIGIBILITY", payload: { packageEligibility: res?.data } });
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceClaimPlan' } });
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            const errCode = res?.status;
                            setTransId(res?.config?.headers['X-Transaction-Id']);
                            setErrorCode(errCode);
                            setNotEligible(true);
                        }
                    } else {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        if (installmentErrorCodes.includes(sourceCode)) {
                            SetIsInstallmentError(true)
                            const errCode = sourceCode;
                            setTransId(res?.config?.headers['X-Transaction-Id']);
                            setErrorCode(errCode);
                            setInstallmentErrorBody(`${t(`${sourceCode}_body`)}`);
                        } else {
                            SetIsInstallmentError(true)
                            const errCode = res?.status;
                            setTransId(res?.config?.headers['X-Transaction-Id']);
                            setErrorCode(errCode);
                            setInstallmentErrorTitle(t(`26239_title`))
                            setInstallmentErrorBody(t(`26239_body`));
                        }
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    SetIsInstallmentError(true)
                    const errCode = res?.status;
                    setTransId(res?.config?.headers['X-Transaction-Id']);
                    setErrorCode(errCode);
                    setInstallmentErrorTitle(t(`26239_title`))
                    setInstallmentErrorBody(t(`26239_body`));

                }
            }).catch(() => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                SetIsInstallmentError(true)
                setInstallmentErrorTitle(t(`26239_title`))
                setInstallmentErrorBody(t(`26239_body`));
            })
    }

    const promotionQualificationAPI = (promotionType: string) => {
        promotionQualification(scData, promotionType)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    const promotiondata = res.data?.cart?.offerContainer[0]?.offerContainerItem[0]?.promotions?.default;

                    dispatch({ type: "PROMOTIONS_DATA", payload: { promotionData: promotiondata } });
                    dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceClaimPlan' } });
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    handleApiError(res, stepName);
                }
            }).catch(err => {
                handleApiError(err, stepName);
            })
    }


    const handleResend = () => {
        dispatch({ type: "LOADER", payload: { loading: true } })

        cemResendOTP(refId)
            .then((res: any) => {
                if (res?.status === 204) {
                    setotpValue('');
                    setIsOTPDisabled(false);
                    dispatch({ type: "LOADER", payload: { loading: false } })
                    setTimer(120);
                    setShowOTPError(true);
                } else if (res?.status === 260 && res?.data?.status?.sourceCode === "MAPI-260-1") {
                    setTimer(0);
                    setotpValue('');
                    setResendOption(false);
                    setErrorMessage(t("You_exceeded_the_maximum_amount_of_requests"));
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    setErrorCode(res?.status);
                    setIsGenericError(true);
                }
            })
    }

    const handleBackArrow = () => {
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    const handleNotEliglible = () => {
        setNotEligible(false);
        document.body.style.overflow = 'auto';
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    const handleGraphqlError = () => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        setErrorModal(false);
        document.body.style.overflow = 'auto';
        window.location.reload();
    }

    const handleGenericError = () => {
        setIsGenericError(false);
        dispatch({ type: 'LOADER', payload: { loading: false } });
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    const handleServiceError = () => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        setIsServiceError(false);
        document.body.style.overflow = 'auto';
        window.location.href = homePageUrl
    }

    return (
        <>
            <div className='TransactionID' id="TransactionID" style={{ display: 'none' }}>{transId}</div>
            <div className='ErrorCode' id="ErrorCode" style={{ display: 'none' }}>{errorCode}</div>
            <HeaderNavigation
                rtl={rtl}
                percent={50}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Verify__Container'>
                <div className='SL__headerText'>
                    <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Verify_heading')}</Typography>
                    <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                        {t('Verify_Subheading')}
                        <div className='Verify__Msisdn'>{msisdn}.</div>
                        <div>{t('Verify_ToContinue')}</div>
                    </Typography>
                </div>

                <div className='Verify__OTP'>
                    <OTP id="otp-input" isDisabled={isOTPDisabled} rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                    {timer > 0 ? (
                        <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                            {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                        </Typography>
                    ) : showOTPError ? (
                        <Typography className='Verify__otpError' rtl={rtl}>
                            {errorMessage}
                            {resendOption && <span id='resend-otp' className='Verify__sendAgain_error' onClick={handleResend}>
                                {t("Send_again")}
                            </span>}

                        </Typography>
                    ) : (
                        <Typography className='Verify__Resend' rtl={rtl}>
                            {t("Didnt_receive_the_code")}
                            <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                                {t("Send_again")}
                            </span>
                        </Typography>
                    )}
                </div>


                {notEligible && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={activeFlow === 'subsidy' ? subsidyErrorTitle : t('installment_plan_not_eligible')}
                        description={activeFlow === 'subsidy' ? subsidyErrorBody : t('installment_Number_not_eligible')}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleNotEliglible}
                    />
                )}

                {notCustomer && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={t('Not_a_mobily_number')}
                        description={t('we_didnot_recognize_number')}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleNotCustomer}
                    />
                )}
                {isInstallmentError && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={installmentErrorTitle}
                        description={installmentErrorBody}
                        firstButtonText={t("close")}
                        modalFirstButtonClick={handleInstallmentPopup}
                    />
                )}

                {showError && <ErrorModal
                    id={'interval-server-error'}
                    rtl={rtl}
                    title={t("generic_technical_error_title")}
                    description={t("generic_technical_error_message")}
                    firstButtonText={t('close')}
                    modalFirstButtonClick={handleInstallmentPopup}
                />}

                {/* <Button
                    rtl={rtl}
                    id="login-button"
                    className="Verify__Btn"
                    variant={otpValue.length === 4 ? "default" : "disabled"}
                    onClick={handleOTPSubmit}
                >
                    {'Continue'}
                </Button> */}
                {errorModal && (
                    <ErrorModal
                        id='error-select-variant'
                        rtl={rtl}
                        title={errorTitle}
                        description={""}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleGraphqlError}
                    />
                )}

                {isGenericError && (
                    <ErrorModal
                        id={'otp_page_generic_error'}
                        rtl={rtl}
                        title={""}
                        description={t('Try_again', { source_code: t(errorCode) })}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleGenericError}
                    />
                )}

                {isServiceError && (
                    <ErrorModal
                        id={'service_busy_error_handling'}
                        className="Error__Modal_updated"
                        rtl={rtl}
                        title={t("Some_of_our_services_are_busy")}
                        description={""}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleServiceError}
                    />
                )}
            </div>
        </>
    )
}

export default DeviceOTP